export const ProfileData = {
    Name: 'Test Name Pradip'
};